import {orderService} from '../../services/service-factory';

export default {
  data: function() {
    return {
      orderService: undefined
    };
  },
  created: function() {
    this.orderService = orderService;
  }
};
